import PropTypes from 'prop-types';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import styles from './FJButtonChoose.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';

const FJButtonChoose = props => {
    const { currentValue, onChange, list, title, renderTitle } = props;
    const curModelObj = list.find(item => item.value === currentValue);

    return (
        <div className={styles.models_box}>
            {renderTitle ? renderTitle : <div className={styles.models_title}>{title}</div>}
            <div className={styles.models_list_box}>
                {list.map((item, index) => {
                    return (
                        <FJHoverBoardGradation
                            key={index}
                            active={curModelObj.name === item.name}
                            className={classNames(styles.models_board_gradation, {
                                [styles.models_board_gradation_hover]: !(curModelObj.value === item.value),
                            })}
                            contentClassName={styles.models_item}
                            onClick={() => onChange && onChange(item.value)}
                        >
                            {item.icon ? <item.icon /> : ''}
                            <div className={styles.models_name}>{FJLocalStore._(item.name)}</div>
                        </FJHoverBoardGradation>
                    );
                })}
            </div>
        </div>
    );
};

FJButtonChoose.propTypes = {
    curModel: PropTypes.string,
    onChange: PropTypes.func,
    renderTitle: PropTypes.object,
};

export default FJButtonChoose;
